import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from '../../modal';
import { bodyAppendDivElement, BodyAppendDivElementProps, removeBodyChild } from '../../utils';
import './message-center.less';

interface DialogMessageCenter {
  message: string;
  onClose?: () => void;
  duration?: number;
  showMask?: boolean;
  className?: string;
}

const ModalRender = (props: DialogMessageCenter & BodyAppendDivElementProps) => {
  const { duration, elementId, ...otherProps } = props;
  const [visible, setVisible] = useState(false);

  const onClose = hooks.useCallbackRef(() => {
    setVisible(false);
    props.onClose?.();
  });

  useEffect(() => {
    setVisible(true);
  }, []);

  const onAfterClose = hooks.useCallbackRef(() => {
    removeBodyChild(`#${elementId}`);
  });
  const onAfterOpen = hooks.useCallbackRef(() => {
    setTimeout(() => {
      onClose();
    }, duration || 2000);
  });

  const onMaskClick = hooks.useCallbackRef(() => {
    if (!props.onClose) {
      setVisible(false);
    }
  });

  return (
    <Modal
      {...otherProps}
      visible={visible}
      getContainer={props.divElement}
      onClose={onClose}
      onAfterClose={onAfterClose}
      onAfterOpen={onAfterOpen}
      destroyOnClose={true}
      className={classNames('v-dialog-message-center', props.className)}
      onMaskClick={onMaskClick}
      mask={props.showMask ? true : false}
    >
      {props.message}
    </Modal>
  );
};

export const dialogMessageCenter = (props: DialogMessageCenter) => {
  const { divElement, elementId } = bodyAppendDivElement();
  ReactDOM.render(<ModalRender {...props} divElement={divElement} elementId={elementId} />, divElement);
};
